import {Component, OnInit} from '@angular/core';
import {ToasterService} from 'angular2-toaster';
import {CatalogService} from '../catalogue/catalog-api/catalog.service';
import {GeneralConstants} from '../shared/general.constants';
// tslint:disable-next-line:import-blacklist
import {Subject} from 'rxjs';

const DEBOUNCE_TIME = 500;
const ES_RESULTS_SIZE = 20;
const ES_LARGER_SEARCH_AMOUNT = 100;

@Component({
    selector: 'global-search',
    templateUrl: 'global-search-titles.component.html',
    styleUrls: ['global-search-titles.component.scss']
})
export class GlobalSearchTitlesComponent implements OnInit {
    // Navigation
    private navIndex = 0;

    // Checkboxes
    private checkboxes = {
        show: true,
        movie: false,
        talent: false,
        sport: false,
        extended: false
    };
    private shouldDoSearch = false;

    // Checkboxes and values for original country/language/network filters
    private originalCheckboxes = {
        country: false,
        language: false,
        network: false,
        catalogState: false
    };
    private countrySubject = new Subject<string>();
    private originalCountry = '';
    private languageSubject = new Subject<string>();
    private originalLanguage = '';
    private networkSubject = new Subject<string>();
    private originalNetwork = '';
    private catalogStates;
    private catalogStateSubject = new Subject<string>();
    private catalogState = '';

    // Subject for search debounce and search value
    private subject = new Subject<string>();
    private searchValue = '';
    private size = 1000;
    private searchIndex = 'genome-search-d-test';

    // Page booleans
    private searchLoading = false;

    // ES Results
    private results = [];

    // Selected show for catalog-manage component
    private selectedShow;

    // Boolean for title creation
    private createTitleRequests = false;

    // Number of hits for the ES search and details for loading more
    private totalResultsMetadata = 0;
    private totalResultsImdb = 0;
    private from = 0;
    private largerSearch = false;
    private hasMore = false;
    public genreCheckBox = false;
    public d360CheckBox = true;

    public newsCheckBox = false;
    public platformCheckBox = false;

    public placeHolderValue = 'Search for title';

    private totalTimeTaken = 0;
    wordCount: any;
    private words: any;
    private esIndex = 'series_metadata';

    constructor(private catalogService: CatalogService,
                private toasterService: ToasterService,
                private generalConstants: GeneralConstants) {
    }

    ngOnChange() {
        console.log('change')
    }

    ngOnInit() {
        this.catalogStates = [''].concat(this.generalConstants.getCatalogStates());
        this.countrySubject.debounceTime(DEBOUNCE_TIME)
            .distinctUntilChanged()
            .subscribe(country => {
                this.shouldDoSearch = true;
                this.subject.next(this.searchValue);
            });
        this.languageSubject.debounceTime(DEBOUNCE_TIME)
            .distinctUntilChanged()
            .subscribe(language => {
                this.shouldDoSearch = true;
                this.subject.next(this.searchValue);
            });
        this.networkSubject.debounceTime(DEBOUNCE_TIME)
            .distinctUntilChanged()
            .subscribe(network => {
                this.shouldDoSearch = true;
                this.subject.next(this.searchValue);
            });
        this.catalogStateSubject.debounceTime(DEBOUNCE_TIME)
            .distinctUntilChanged()
            .subscribe(catalogState => {
                this.shouldDoSearch = true;
                this.subject.next(this.searchValue);
            });
        this.subject.debounceTime(DEBOUNCE_TIME)
            .distinctUntilChanged((prev, curr) => prev === curr && !this.shouldDoSearch)
            .subscribe(searchValue => {
                // Search value has changed, reset results, total results and from
                this.results = [];
                this.totalResultsImdb = 0;
                this.totalResultsMetadata = 0;
                this.from = 0;
                this.doSearch(searchValue);
            });
    }

    wordCounter() {
        //alert(this.text.nativeElement.value)
        this.wordCount = this.searchValue ? this.searchValue.split(/\s+/) : 0;
        this.words = this.wordCount ? this.wordCount.length : 0;
        //console.log(this.words);
    }

    doSearch(searchValue) {

        if (this.d360CheckBox) {
            if (this.navIndex === 2) {
                this.esIndex = 'talent_metadata';
                this.searchIndex = 'genome-search-movie-d-test';
            } else if (this.navIndex === 1) {
                this.esIndex = 'movie_metadata';
                this.searchIndex = 'genome-search-movie-d-test';
            } else {
                this.esIndex = 'series_metadata';
                this.searchIndex = 'genome-search-d-test';
            }
        }
        if (this.d360CheckBox) {
            this.size = 1000;
        } else {
            this.size = 10;
        }

        const t0 = performance.now();
        //console.log(t0);
        this.shouldDoSearch = false;
        this.searchLoading = true;
        this.searchValue = searchValue;
        const typeFilters = Object.keys(this.checkboxes)
            .filter(item => item !== 'extended' && this.checkboxes[item]);
        const originalFilters = {};
        if (this.originalCheckboxes.country && this.originalCountry && this.originalCountry !== '') {
            originalFilters['data.original_country.*'] = this.originalCountry;
        }
        if (this.originalCheckboxes.language && this.originalLanguage && this.originalLanguage !== '') {
            originalFilters['data.original_language.*'] = this.originalLanguage;
        }
        if (this.originalCheckboxes.network && this.originalNetwork && this.originalNetwork !== '') {
            originalFilters['data.original_network.*'] = this.originalNetwork;
        }
        if (this.originalCheckboxes.catalogState && this.catalogState && this.catalogState !== '') {
            originalFilters['catalog_state'] = this.catalogState;
        }
        // If there are original filters, but no search value, use an unlimited (very large) search size
        this.largerSearch = false;
        if (Object.keys(originalFilters).length > 0 && searchValue === '') {
            this.largerSearch = true;
        }
        // const queryJSON = this.catalogService.createEsQuery(
        //     searchValue, this.largerSearch ? ES_LARGER_SEARCH_AMOUNT : ES_RESULTS_SIZE, typeFilters, originalFilters,
        //     this.catalogService.getEsDefaultSource(), 'catalog', this.from
        // );
        //

        this.wordCounter();
        const queryJSON = this.catalogService.createGlobalSearchEsQuery(searchValue, this.words, this.searchIndex, this.size);

        if (this.checkboxes.extended) {
            // Call master_catalog metadata and imdb_titles general_info indexes
            const imdbTypeFilters = typeFilters.map((item) => {
                if (item === 'show') {
                    return 'tvSeries';
                } else if (item === 'movie') {
                    return 'movie';
                } else {
                    return null;
                }
            }).filter((item) => item);


            // Always call the metadata search, even if there are no more results
            const functionsToPromise = [this.catalogService.callGlobalSearchEsProxyCustomQuery(
                queryJSON,
                this.esIndex, 'template'
            )];
            if (this.totalResultsImdb > this.from || this.totalResultsImdb === 0) {
                const imdbQueryJSON = this.catalogService.createEsQuery(
                    searchValue, ES_RESULTS_SIZE, imdbTypeFilters, null, [
                        'AKAs',
                        'Countries',
                        'ResourceId',
                        'PlotSummary',
                        'ProductionCompanies',
                        'Title',
                        'Year'
                    ],
                    'imdb', this.from
                );
                functionsToPromise.push(this.catalogService.callEsProxyCustomQuery(
                    imdbQueryJSON,
                    'imdb_metadata'
                ));
            }
            Promise.all(functionsToPromise)
                .then((res) => {
                    let results = res[0].hits.hits.map(this.catalogService.mapEsResultItem);
                    if (res[1]) {
                        const imdbResArray = res[1].hits.hits.map(this.catalogService.mapEsImdbResultItem)
                            .filter(item => !item.parrotId);
                        this.totalResultsImdb = res[1].hits.total;
                        results = results.concat(
                            imdbResArray
                        );
                    }
                    this.totalResultsMetadata = res[0].hits.total;
                    this.results = this.results.concat(results);
                    const pageSize = this.largerSearch ? ES_LARGER_SEARCH_AMOUNT : ES_RESULTS_SIZE;
                    if (this.totalResultsMetadata > (this.from + pageSize) || this.totalResultsImdb > (this.from + pageSize)) {
                        this.hasMore = true;
                    } else {
                        this.hasMore = false;
                    }
                    this.searchLoading = false;
                })
                .catch((err) => {
                    console.error('Failed to call the ES proxy in the catalog API' + err.toString());
                    this.toasterService.pop('error', 'Failed to call the ES proxy in the catalog API');
                    this.searchLoading = false;
                });
        } else {
            let template = 'template';
            if (this.newsCheckBox) {
                template = 'template';
            }
            if (this.newsCheckBox) {
                template = 'template';
            }
            if (this.newsCheckBox) {
                template = 'template';
            }

            this.catalogService.callGlobalSearchEsProxyCustomQuery(
                queryJSON,
                this.esIndex, template
            ).then((res) => {

                this.results = this.results.concat(res.hits.hits.map(this.catalogService.mapGlobalSearchEsResultItem))

                if (!this.d360CheckBox) {
                    this.results = this.results.filter(item => item.catalogState === 'client_ready');
                }

                this.totalResultsMetadata = res.hits.total.value;
                const pageSize = this.largerSearch ? ES_LARGER_SEARCH_AMOUNT : ES_RESULTS_SIZE;
                if (this.totalResultsMetadata > (this.from + pageSize)) {
                    this.hasMore = true;
                } else {
                    this.hasMore = false;
                }
                this.searchLoading = false;
                const t1 = performance.now();
                // console.log(t1);
                const timeTaken = Math.floor(t1 - t0);
                this.totalTimeTaken = timeTaken;
            }).catch((err) => {
                console.error('Failed to call the ES proxy in the catalog API' + err.toString());
                this.toasterService.pop('error', 'Failed to call the ES proxy in the catalog API');
                this.searchLoading = false;
            });


        }
    }

    addSearchValue(item) {
        // console.log('ii');

        return {
            keyword: this.searchValue,
        };
    }

    handleLoadMore() {
        if (this.largerSearch) {
            this.from = this.from + ES_LARGER_SEARCH_AMOUNT;
        } else {
            this.from = this.from + ES_RESULTS_SIZE;
        }
        this.doSearch(this.searchValue);
    }

    handleNavSelect(index) {
        this.navIndex = index;
        this.searchValue = '';
        this.results = [];
    }

    handleOpen(result) {
        // console.log('handle open ', result);
        if (!this.selectedShow || (this.selectedShow && this.selectedShow.parrot_id !== result.parrotId)) {
            this.selectedShow = {
                parrot_id: result.parrotId,
                title: result.title,
                display_name: result.displayName,
                catalog_state: result.catalogState
            };
        } else if (this.selectedShow && this.selectedShow.parrot_id === result.parrotId) {
            // Trigger a change for the property
            setTimeout(() => {
                this.selectedShow = {
                    parrot_id: undefined,
                    catalog_state: undefined,
                    title: undefined,
                    display_name: undefined
                };
            });
            setTimeout(() => {
                this.selectedShow = {
                    parrot_id: result.parrotId,
                    title: result.title,
                    display_name: result.displayName,
                    catalog_state: result.catalogState
                };
            });
        }
    }

    onKeyUp(searchValue) {
        //console.log(this.searchValue);
        this.searchValue = searchValue;
        if (this.shouldSearch()) {
            this.subject.next(searchValue);
        } else {
            this.results = [];
        }
    }

    public onD360Changed(value) {
        this.d360CheckBox = value;
        this.onKeyUp(this.searchValue);
        this.shouldDoSearch = true;
        //console.log(this.d360CheckBox);
        // if(!value) {
        //     this.results = this.results.filter(item => item.catalog_state === 'client_ready');
        // }
        // if(value) {
        //     this.placeHolderValue = 'Search on D360 or Search for title';
        //     this.searchIndex = 'genome-search-d-test';
        //     if(this.navIndex==1){
        //         this.searchIndex = 'genome-search-movie-d-test';
        //     }else{
        //         this.searchIndex = 'genome-search-d';
        //     }
        // }else{
        //     this.placeHolderValue = 'Search on TVGeek or Search for title';
        //     this.searchIndex = 'genome-search-d-test';
        //     if(this.navIndex==1){
        //         this.searchIndex = 'genome-search-movie-d-test';
        //     }else{
        //         this.searchIndex = 'genome-search-d-test';
        //     }
        // }
    }

    shouldSearch() {
        return this.searchValue || (this.originalCheckboxes.country ||
            this.originalCheckboxes.language || this.originalCheckboxes.network);
    }
}



// WEBPACK FOOTER //
// ./src/app/global-search/global-search-titles.component.ts